<template>
  <div class="foot">
    <div class="box">
      <ul>
        <li
          v-for="(item,index) in list"
          :key="index">
          <div class="title">{{item.title}}</div>
          <div class="list">
            <p
              v-for="(item1,index1) in item.listC"
              :key="index1">
              <span>{{item1}}</span>
            </p>
          </div>
        </li>
        <li class="phone">
          <div class="title">客服电话</div>
          <div class="phoneNum">
            <span>400-0127-985</span>
          </div>
        </li>
        <li class="weiChat">
          <div class="title">微信公众号</div>
          <div class="img">
            <img src="../assets/img/gaobao/weiChat.png" alt="">
          </div>
        </li>
      </ul>
    </div>
    <p class="copyright">Copyright © 2021 山东高招教育科技有限公司 ｜ ICP证:鲁B2-20100257</p>
  </div>
</template>

<script>
  export default {
    name: "foot",  // 页脚
    data() {
      return {
        list: [
          {
            title: '高招简介',
            listC: [ '关于我们', '联系我们', '在线客服' ]
          },
          {
            title: '常见问题',
            listC: [ '忘记登录密码', '会员卡如何使用', '注册问题', '相关名词解释' ]
          },
          {
            title: '官方声明',
            listC: [ '服务条款', '免责声明', '意见反馈' ]
          },
          {
            title: '关注我们',
            listC: [ '微信公众号', '手机客户端' ]
          }
        ]
      }
    },
    created() {

    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  @import "../style/common";
  .foot {
    padding: 90px 0 20px;
    background: #21252B;
    border: 1px solid #979797;
    .box{
      padding-bottom: 20px;
      border-bottom: 1px solid #444;
      ul{
        display: flex;
        justify-content: space-between;
        max-width: 1200px;
        margin: auto;
        li{
          .title{
            color: #fff;
          }
          .list{
            margin-top: 8px;
            p{
              span{
                font-size: 12px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.65);
              }
            }
          }
        }
        li.phone{
          text-align: right;
          .phoneNum{
            margin-top: 8px;
            span{
              color: #666;
            }
          }
        }
        li.weiChat{
          text-align: right;
          .img{
            margin-top: 8px;
          }
        }
      }
    }
    .copyright{
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.65);
    }
  }
</style>
